import * as types from '../actions/actiontype'
import * as appUtility from '../../../infrastructure/apputilityfunctions'
import * as appConstants from '../../../overrides/appconstants'

const initialState = {
}

initialState.complaintSearch = {
    complaintId: null,
    complaintNumber: null,
    source: null,
    sourceComplaintNumber: null,
    customerName: null,
    statusName: null,
    openingDate: null,
    registerDate: null,
    closingDate: null,
    lineOfBuisness: null,
    subLineOfBuisness: null,
    isSubEnabled: null,
    islobEnabled: null,
    sortString: null,
    searchResult: {
        result: []
    },
    searchClass: "collapse show",
    searchResultClass: "collapse show",
}

initialState.confirmPopup = {
    showConfirmPopup: false,
    message: null,
    resolve: null,
    showYes: false,
    showNo: false,
    showOk: false,
    isComp: false,
}

initialState.newComplaint = {
    complaintId: null,
    complaintNumber: null,
    source: null,
    sourceComplaintNumber: null,
    compliantBelongsToAlSagr: 'Yes',
    fullName: null,
    duplicateComplaint: 'No',
    email: null,
    mobileNumber: null,
    lineOfBuisness: null,
    subLineOfBuisness: null,
    emiratesId: null,
    policyNumber: null,
    make: null,
    model: null,
    plateNumber: null,
    chassisNumber: null,
    claimNumber: null,
    membershipNumber: null,
    complaintId: null,
    medicalCardNumber: null,
    eventCode: null,
    workshopName: null,
    originalComplaintNumber: null,
    statusName: 1,
    openingDate: appUtility.getCurrentDate(),
    comment:null,
    termsCheckbox:null,
    documentList: [],
}
initialState.userLog = {
    result: [],
}
initialState.comment = {

    comment: null,
    commentUser: null,
    commentType: null,
    commentDate: appUtility.getCurrentDate(),
}

initialState.documents = {
    documentList: [],
    selectedDocuments: [],
}
initialState.validationsErrorMessages = {
    insuredValidations: {
        dateOfBirthMessage: null,
        emailMessage: null,
        eIdMessage: null,
        phoneMessage: null,
    }
}
initialState.complaintDetails = {
    complaintId: null,
    complaintAbout: [],
    complaintDesc: null,
    subLineOfBuisness: null,
    lineOfBuisness: null,
    statusName: null,
    openingDate: appUtility.getCurrentDate(),
    registerDate: appUtility.getCurrentDate(),
    replyDate: null,
    replyDateBy: null,
    closingDate: null,
    closingBy: null,
    closingDateBy: null,
    complaintResult: null,
    reason: null,
    complaintDetails: null,
    isTypeEnabled: null,
    accidentDate: null,
    claimReportingDate: null,
    claimRegistrationDate: null,
    dateOfEstimation: null,
    dateOfInspection: null,
    lpoDate: null,
    totalLossDate: null,
    chequeDate: null,
    rowVersion: null,
    result: [],
}
initialState.complaintDetailsOriginal = {
    complaintId: null,
    complaintAbout: [],
    complaintDesc: null,
    subLineOfBuisness: null,
    lineOfBuisness: null,
    statusName: null,
    openingDate: null,
    registerDate: appUtility.getCurrentDate(),
    replyDate: null,
    replyDateBy: null,
    closingDate: null,
    closingBy: null,
    closingDateBy: null,
    complaintResult: null,
    reason: null,
    complaintDetails: null,
    isTypeEnabled: null,
    accidentDate: null,
    claimReportingDate: null,
    claimRegistrationDate: null,
    dateOfEstimation: null,
    dateOfInspection: null,
    lpoDate: null,
    totalLossDate: null,
    chequeDate: null,
    result: [],
}
initialState.complaintNumberSearch = {
    searchText: null,
    searchResult: [],

}
initialState.successDialoge = {
    isOpen: false,
    message: null,
    type: null,
}
initialState.modalsState = {
    showNewComplaintModal: null,
    showCommentModal: null,
    showTab: null,
    showDocumentModal: null,
    showComplaintSearchResultsModal: null,
    showComplaintsModal: null,
    showCurrentComplaintModal: null,
    showComplaintNumberSearchModal: null,
}
initialState.masters = {
    subLOBMasters: [
        { subLobId: 0, subLobCode: null, subLobName: null }
    ],
    subLOBSearchMasters: [
        { subLobId: 0, subLobCode: null, subLobName: null }
    ],
    lobMasters: [
        { lobId: 0, lobCode: null, lobName: null }
    ],
    lobSeachMasters: [
        { lobId: 0, lobCode: null, lobName: null }
    ],
    statusMasters: [
        { statusId: 0, statusCode: null, statusName: null }
    ],
    customerNameMasters: [
        { domainValue: 0, domainValueName: null }
    ],
    sourceMasters: [
        { sourceId: 0, sourceCode: null, sourceName: null }
    ],
    // modelMaster: [
    //     { modelId: 0, modelName: null }
    // ],
    makeMasters: [
        { makeId: 0, makeCode: null, makeName: null }
    ],
    duplicateComplaintMasters: [
        { /* domainValue:1, */domainValueName: "Yes" },
        {/* domainValue:2, */domainValueName: "No" }
    ],
    compliantBelongsToAlSagrMasters: [
        { /* domainValue:1, */domainValueName: "Yes" },
        {/* domainValue:2, */domainValueName: "No" }
    ],
    complaintAboutMasters: [
        { complaintTypeId: 0, complaintTypeCode: null, complaintTypeName: null }
    ],
    complaintAboutSearchMasters: [
        { complaintTypeId: 0, complaintTypeCode: null, complaintTypeName: null }
    ],
    complaintResultMasters: [
        { domainValue: 0, domainValueName: null }
    ],
    commentTypeMasters: [
        { domainValue: 0, domainValueName: null }
    ],
    compliantTypeMasters: [
        { domainValue: 0, domainValueName: null }
    ],
}
initialState.whistleBlowing = {
    fullName: null,
    email: null,
    mobileNumber: null,
    comment:null,
    documentList: [],
}

export default function complaintsandfeedbackReducer(state = initialState, action) {
    switch (action.type) {
        case types.COLLAPSE_SEARCH:
            var collapseClass = null
            if (action.payload == true) {
                collapseClass = "collapse"
            }
            else {
                collapseClass = "collapse show"
            }
            return {
                ...state,
                complaintSearch: {
                    ...state.complaintSearch,
                    searchClass: collapseClass
                }
            }
        case types.COLLAPSE_SEARCH_RESULT:
            var collapseClass = null
            if (action.payload == true) {
                collapseClass = "collapse"
            }
            else {
                collapseClass = "collapse show"
            }
            return {
                ...state,
                complaintSearch: {
                    ...state.complaintSearch,
                    searchResultClass: collapseClass
                }
            }
        case types.UPDATE_MODAL_DISPLAY_STATE: {
            return {
                ...state,
                modalsState: {
                    ...state.modalsState,
                    [action.payload.name]: action.payload.value
                }
            }
        }
        case types.GET_INS_SHARED_MASTERS_END:

            return {
                ...state,
                masters: {
                    ...state.masters,
                    insuredTypeMasters: action.result.insuredType,
                    businessTypeMaster: action.result.businessType,
                    documentTypeMasters: action.result.documentType,
                    visaEmirateMasters: action.result.emirates,
                    insuredVisaTypeMasters: action.result.insuredVisaType,
                    stageMasters: action.result.stageType,
                    branchMasters: action.result.branchType,
                    productMasters: action.result.productType,
                    amlMasters: action.result.amlType,
                    sponsorMasters: action.result.sponsorType,
                    productTypeMasters: action.result.productTypeMasters,
                    regulatoryMasters: action.result.regulatoryName,
                    cashModeMasters: action.result.cashMode,
                    premiumModeMasters: action.result.premiumMode,
                    installmentTypeMasters: action.result.installmentType,
                    //agentMasters: action.result.agent,
                    ageSlabMasters: action.result.ageSlab,
                    schemeMasters: action.result.scheme,
                    tariffCalculationMasters: action.result.tariffCalculation,
                    maritalStatusMasters: action.result.maritalStatus,
                    entityTypeMasters: action.result.entityType,
                    nationalityMasters: action.result.nationality,
                    salutationMasters: action.result.salutation,
                    collectionPointMasters: action.result.collectionPoint,
                    currencyCodeMasters: action.result.currency,
                    lineOfBusinessMasters: action.result.lineOfBuisness,
                    riskClassMasters: action.result.riskClass,
                    commentTypeMasters: action.result.commentType,
                    /*Member Page*/
                    relationMasters: action.result.relation,
                    salaryBandMasters: action.result.salaryBand,
                    professionMasters: action.result.profession,
                    idTypeMasters: action.result.idType,
                    dhaMemberTypeMasters: action.result.dhaMemberType,
                    workingEmirateMasters: action.result.emirates,
                    residentEmirateMasters: action.result.emirates,
                    vatTypeMasters: action.result.vatType,
                    chargesTypeMasters: action.result.chargesType,
                    applyTypeMasters: action.result.applyType,
                    visaTypeMasters: action.result.visaType,
                    endorsementMastersOriginal: action.result.endorsementMaster,
                    endorsementMasters: [...new Map(action.result.endorsementMaster.map(item => [item["endorsementId"], item])).values()],
                    claimSourceMasters: action.result.claimSource,
                    priorityMasters: action.result.priority,
                    batchTypeClaimsMasters: action.result.batchTypeClaims,
                    payableToMasters: action.result.payableTo,
                    departmentMasters: action.result.departmentMaster,
                    countryMasters: action.result.countryMaster,
                    poTypeMasters: action.result.poType,
                    monthMasters: action.result.month,
                    //yearMasters: appUtility.getYearMasters(),
                    installmentConfigMasters: action.result.installmentConfig,
                    natureOfGroupMasters: action.result.natureOfGroup,
                    complaintResultMasters: action.result.complaintResult,
                    /*New masters*/
                    fobMasters: action.result.fobMasters,
                    providerTypeMasters: action.result.providerTypeMasters,
                    paymentModeMasters: action.result.paymentModeMasters,
                    encounterTypeMasters: action.result.encounterTypeMasters,
                    diagnosisTypeMasters: action.result.diagnosisTypeMasters,
                    memberFieldMasters: action.result.memberFieldMasters,
                    operatorMasters: action.result.operatorMasters,
                    //for claims
                    paymentTypeMasters: action.result.paymentTypeMasters
                }
            }
        case types.GET_SHARED_COMPLAINTS_FEEDBACK_MASTERS_END: {
            return {
                ...state,
                masters: {
                    ...state.masters,
                    subLOBMasters: action.payload.subLobValues,
                    subLOBSearchMasters: action.payload.subLobValues,
                    lobMasters: action.payload.lobValuesFeedback,
                    lobSeachMasters: action.payload.lobValues,
                    statusMasters: action.payload.statusValues,
                    sourceMasters: action.payload.sourceValues,
                    makeMasters: action.payload.makeValues,
                    // modelMaster: action.payload.modelValues ?? [{ modelId: 0, modelName: null }],
                    complaintAboutMasters: action.payload.complaintTypeValues,
                    complaintAboutSearchMasters: action.payload.complaintTypeValues,
                    compliantTypeMasters : action.payload.compliantTypeMasters
                }
            }
        }
        case types.UPDATE_COMPLAINTS_SEARCH_PARAMS: {
            return {
                ...state,
                complaintSearch: {
                    ...state.complaintSearch,
                    [action.payload.name]: action.payload.value
                }
            }
        }
        case types.RESET_COMPLAINT_SEARCH_INFORMATION: {
            return {
                ...state,
                complaintSearch: {
                    ...state.complaintSearch,
                    complaintNumber: null,
                    source: null,
                    sourceComplaintNumber: null,
                    customerName: null,
                    statusName: null,
                    openingDate: null,
                    registerDate: null,
                    closingDate: null,
                    lineOfBuisness: null,
                    subLineOfBuisness: null,
                    searchResult: [],
                },
            }
        }
        case types.UPDATE_NEW_COMPLAINTS_PARAMS: {
            return {
                ...state,
                newComplaint: {
                    ...state.newComplaint,
                    [action.payload.name]: action.payload.value
                }
            }
        }
        case types.RESET_NEW_COMPLAINT_INFORMATION: {
            return {
                ...state,
                newComplaint: {
                    ...state.newComplaint,
                    complaintNumber: null,
                    source: null,
                    sourceComplaintNumber: null,
                    compliantBelongsToAlSagr: 'Yes',
                    fullName: null,
                    duplicateComplaint: 'No',
                    email: null,
                    mobileNumber: null,
                    lineOfBuisness: null,
                    subLineOfBuisness: null,
                    emiratesId: null,
                    policyNumber: null,
                    make: null,
                    model: null,
                    plateNumber: null,
                    chassisNumber: null,
                    claimNumber: null,
                    membershipNumber: null,
                    eventCode: null,
                    complaintResult: null,
                    originalComplaintNumber: null,
                    complaintId: null,
                },
            }
        }
        case types.RESET_NEW_COMPLAINT_INFORMATION_WITHOUT_COMPLAINT_NUMBER: {
            return {
                ...state,
                newComplaint: {
                    ...state.newComplaint,
                    complaintId: null,
                    complaintNumber: null,
                    source: null,
                    sourceComplaintNumber: null,
                    compliantBelongsToAlSagr: 'Yes',
                    fullName: null,
                    duplicateComplaint: 'No',
                    email: null,
                    mobileNumber: null,
                    lineOfBuisness: null,
                    subLineOfBuisness: null,
                    emiratesId: null,
                    policyNumber: null,
                    make: null,
                    model: null,
                    plateNumber: null,
                    chassisNumber: null,
                    claimNumber: null,
                    membershipNumber: null,
                    complaintId: null,
                    medicalCardNumber: null,
                    eventCode: null,
                    workshopName: null,
                    originalComplaintNumber: null,
                    statusName: 1,
                    openingDate: appUtility.getCurrentDate(),
                    comment:null,
                },
            }
        }
        case types.UPDATE_MODAL_DISPLAY_STATE: {
            return {
                ...state,
                modalsState: {
                    ...state.modalsState,
                    [action.payload.name]: action.payload.value
                }
            }
        }
        case types.UPDATE_COMPLAINTS_DETAILS_PARAMS: {
            return {
                ...state,
                complaintDetails: {
                    ...state.complaintDetails,
                    [action.payload.name]: action.payload.value
                }
            }
        }
        case types.RESET_COMPLAINT_DETAILS_INFORMATION: {
            return {
                ...state,
                complaintDetails: {
                    complaintId: null,
                    complaintAbout: [],
                    complaintDesc: null,
                    subLineOfBuisness: null,
                    lineOfBuisness: null,
                    statusName: null,
                    openingDate: null,
                    registerDate: appUtility.getCurrentDate(),
                    replyDate: null,
                    replyDateBy: null,
                    closingDate: null,
                    closingBy: null,
                    closingDateBy: null,
                    complaintResult: null,
                    reason: null,
                    complaintDetails: null,
                    accidentDate: null,
                    claimReportingDate: null,
                    claimRegistrationDate: null,
                    dateOfEstimation: null,
                    dateOfInspection: null,
                    lpoDate: null,
                    totalLossDate: null,
                    chequeDate: null,
                    isTypeEnabled: null,
                    result: [],
                },
            }
        }
        case types.UPDATE_COMMENT_PARAMS: {
            return {
                ...state,
                comment: {
                    ...state.comment,
                    [action.payload.name]: action.payload.value
                }
            }
        }
        case types.RESET_COMMENT_INFORMATION: {
            return {
                ...state,
                comment: {
                    comment: null,
                    complaintId: null,
                    commentUser: null,
                    commentType: null,
                    commentDate: appUtility.getCurrentDate(),
                },
            }
        }
        case types.COMPLAINT_MAIN_SET_TAB:
            return {
                ...state,
                complaintMainActiveTab: {
                    ...state.complaintMainActiveTab,
                    complaintMainActiveTab: action.payload
                },
            }
        case types.UPDATE_COMPLAINT_SEARCH_RESULT: {
            console.log("mama", action.pagedResult)
            return {

                ...state,
                complaintSearch: {
                    ...state.complaintSearch,
                    searchResult: action.pagedResult,
                }
            }
        }
        case types.GET_COMPLAINT_DETAILS_END:

            return {
                ...state,
                complaintDetails: {
                    ...state.complaintDetails,
                   // complaintId: action.payload.complaintDetails.complaintId,
                    complaintAbout: action.payload.complaintAbout,
                    complaintDesc: action.payload.complaintDesc,
                    openingDate: action.payload.openingDate == null ? "" : appUtility.formatDate(action.payload.openingDate),
                    registerDate: action.payload.registerDate == null ? "" : appUtility.formatDate(action.payload.registerDate),
                    replyDate: action.payload.replyDate == null ? "" : appUtility.formatDate(action.payload.replyDate),
                    replyDateBy: action.payload.replyDateBy == null ? "" : appUtility.formatDate(action.payload.replyDateBy),
                    closingDate: action.payload.closingDate == null ? "" : appUtility.formatDate(action.payload.closingDate),
                    closingDateBy: action.payload.closingDateBy == null ? "" : appUtility.formatDate(action.payload.closingDateBy),
                    closingBy: action.payload.closingBy,
                    accidentDate: action.payload.accidentDate == null ? "" : appUtility.formatDate(action.payload.accidentDate),
                    claimReportingDate: action.payload.claimReportingDate == null ? "" : appUtility.formatDate(action.payload.claimReportingDate),
                    claimRegistrationDate: action.payload.claimRegistrationDate == null ? "" : appUtility.formatDate(action.payload.claimRegistrationDate),
                    dateOfEstimation: action.payload.dateOfEstimation == null ? "" : appUtility.formatDate(action.payload.dateOfEstimation),
                    dateOfInspection: action.payload.dateOfInspection == null ? "" : appUtility.formatDate(action.payload.dateOfInspection),
                    lpoDate: action.payload.lpoDate == null ? "" : appUtility.formatDate(action.payload.lpoDate),
                    totalLossDate: action.payload.totalLossDate == null ? "" : appUtility.formatDate(action.payload.totalLossDate),
                    chequeDate: action.payload.chequeDate == null ? "" : appUtility.formatDate(action.payload.chequeDate),
                    complaintResult: action.payload.complaintResult,
                    reason: action.payload.reason,
                    rowVersion: action.payload.rowVersion,
                    complaintDetails: action.payload.complaintDetails,
                    statusName: action.payload.statusName,
                    result: action.payload.comment,

                },
                complaintDetailsOriginal: {
                    ...state.complaintDetailsOriginal,
                    //complaintId: action.payload.complaintDetails.complaintId,
                    complaintAbout: action.payload.complaintAbout,
                    complaintDesc: action.payload.complaintDesc,
                    openingDate: action.payload.openingDate == null ? "" : appUtility.formatDate(action.payload.openingDate),
                    registerDate: action.payload.registerDate == null ? "" : appUtility.formatDate(action.payload.registerDate),
                    replyDate: action.payload.replyDate == null ? "" : appUtility.formatDate(action.payload.replyDate),
                    replyDateBy: action.payload.replyDateBy == null ? "" : appUtility.formatDate(action.payload.replyDateBy),
                    closingDate: action.payload.closingDate == null ? "" : appUtility.formatDate(action.payload.closingDate),
                    closingDateBy: action.payload.closingDateBy == null ? "" : appUtility.formatDate(action.payload.closingDateBy),
                    closingBy: action.payload.closingBy,
                    accidentDate: action.payload.accidentDate == null ? "" : appUtility.formatDate(action.payload.accidentDate),
                    claimReportingDate: action.payload.claimReportingDate == null ? "" : appUtility.formatDate(action.payload.claimReportingDate),
                    claimRegistrationDate: action.payload.claimRegistrationDate == null ? "" : appUtility.formatDate(action.payload.claimRegistrationDate),
                    dateOfEstimation: action.payload.dateOfEstimation == null ? "" : appUtility.formatDate(action.payload.dateOfEstimation),
                    dateOfInspection: action.payload.dateOfInspection == null ? "" : appUtility.formatDate(action.payload.dateOfInspection),
                    lpoDate: action.payload.lpoDate == null ? "" : appUtility.formatDate(action.payload.lpoDate),
                    totalLossDate: action.payload.totalLossDate == null ? "" : appUtility.formatDate(action.payload.totalLossDate),
                    chequeDate: action.payload.chequeDate == null ? "" : appUtility.formatDate(action.payload.chequeDate),
                    complaintResult: action.payload.complaintResult,
                    reason: action.payload.reason,
                    complaintDetails: action.payload.complaintDetails,
                    statusName: action.payload.statusName,
                    result: action.payload.comment,

                },
            }
        case types.GET_COMPLAINT_INFO_END:

            return {
                ...state,
                newComplaint: {
                    ...state.newComplaint,
                   // complaintId: action.payload.complaintInfo.complaintId,
                    complaintNumber: action.payload.complaintNumber,
                    originalComplaintNumber: action.payload.originalComplaintNumber,
                    source: action.payload.sourceName,
                    sourceComplaintNumber: action.payload.sourceComplaintNumber,
                    compliantBelongsToAlSagr: action.payload.compliantBelongsToAlSagr,
                    fullName: action.payload.fullName,
                    duplicateComplaint: action.payload.duplicateComplaint,
                    email: action.payload.email,
                    mobileNumber: action.payload.mobileNumber,
                    lineOfBuisness: action.payload.lineOfBuisness,
                    subLineOfBuisness: action.payload.subLineOfBuisness,
                    emiratesId: action.payload.emiratesId,
                    policyNumber: action.payload.policyNumber,
                    make: action.payload.make,
                    model: action.payload.model,
                    plateNumber: action.payload.plateNumber,
                    chassisNumber: action.payload.chassisNumber,
                    claimNumber: action.payload.claimNumber,
                    membershipNumber: action.payload.membershipNumber,
                    eventCode: action.payload.eventCode,
                    workshopName: action.payload.workshopName,
                    //originalComplaintNumber:action.payload.complaintDetails
                    // result: action.payload

                }

            }
        case types.GET_SUB_LOB_MASTERS_END:
            {
                var subLob = action.payload.subLOBMasters.length == 1 ? action.payload.subLOBMasters[0].subLobId : state.complaintSearch.subLineOfBuisness;
                if (action.payload.section == "complaintSearch") {
                    return {
                        ...state,
                        masters: {
                            ...state.masters,
                            subLOBSearchMasters: action.payload.subLOBMasters
                        },
                        complaintSearch: {
                            ...state.complaintSearch,
                            isSubEnabled: action.payload.status
                        }
                    }
                }
                if (action.payload.section == "subLOB") {
                    return {
                        ...state,
                        masters: {
                            ...state.masters,
                            subLOBMasters: action.payload.subLOBMasters
                        },
                        complaintSearch: {
                            ...state.complaintSearch,
                            isSubEnabled: action.payload.status,
                            subLob: subLob
                        }
                    }
                }
            }
        case types.GET_COMPLAINT_TYPE_MASTERS_END:
            {
                var type = action.payload.complaintAboutMasters.length == 1 ? action.payload.complaintAboutMasters[0].subLobId : state.complaintSearch.subLineOfBuisness;
                if (action.payload.section == "complaintDetails") {
                    return {
                        ...state,
                        masters: {
                            ...state.masters,
                            complaintAboutSearchMasters: action.payload.complaintAboutMasters
                        },
                        complaintDetails: {
                            ...state.complaintDetails,
                            isTypeEnabled: action.payload.status
                        }
                    }
                }
                if (action.payload.section == "complaintType") {
                    return {
                        ...state,
                        masters: {
                            ...state.masters,
                            complaintAboutMasters: action.payload.complaintAboutMasters
                        },
                        complaintDetails: {
                            ...state.complaintDetails,
                            isTypeEnabled: action.payload.status,
                            type: type
                        }
                    }
                }
            }
        case types.UPDATE_COMPLAINT_NUMBER_SEARCH_PARAMS: {
            return {
                ...state,
                complaintNumberSearch: {
                    ...state.complaintNumberSearch,
                    [action.payload.name]: action.payload.value
                }
            }
        }
        case types.RESET_COMPLAINT_NUMBER_SEARCH: {
            return {
                ...state,
                complaintNumberSearch: {
                    ...state.complaintNumberSearch,
                    searchText: null,
                    searchResult: [],
                },
            }
        }
        case types.RESET_COMPLAINT_NUMBER: {
            return {
                ...state,
                newComplaint: {
                    ...state.newComplaint,
                    originalComplaintNumber: null,

                },
            }
        }
        case types.RESET_USER_LOG_INFORMATION: {
            return {
                ...state,
                userLog: {
                    ...state.userLog,
                    result: [],

                },
            }
        }
        case types.RESET_COMPLAINT_SEARCH_RESULT: {
            return {
                ...state,
                complaintSearch: {
                    ...state.complaintSearch,
                    searchResult: [],

                },
            }
        }
        case types.GET_COMPLAINT_NUMBER_RESULTS_END: {
            return {
                ...state,
                complaintNumberSearch: {
                    ...state.complaintNumberSearch,
                    searchResult: action.pagedResult,
                }
            }
        }
        case types.CHANGE_VALIDATION_ERROR_MESSAGE:

            return {
                ...state,
                validationsErrorMessages: {
                    ...state.validationsErrorMessages,
                    insuredValidations: {
                        ...state.validationsErrorMessages.insuredValidations,
                        [action.payload.name]: action.payload.value,
                    }
                }
            }

        case types.RESET_VALIDATION_ERROR_MESSAGE: {
            return {
                ...state,
                validationsErrorMessages: initialState.validationsErrorMessages
            }
        }
       
        case types.UPDATE_FILE_CHANGE_END: {
            return {
                ...state,
                documents: {
                    ...state.documents,
                    documentList: action.payload.updatedFile
                }
            }
        }
        case types.UPDATE_DOCUMENT_PARAMS_END: {
            return {
                ...state,
                documents: {
                    ...state.documents,
                    documentList: action.payload.updatedDocParams
                }
            }
        }
               case types.UPDATE_WHISTLE_BLOWING_PARAMS: {
            return {
                ...state,
                whistleBlowing: {
                    ...state.whistleBlowing,
                    [action.payload.name]: action.payload.value
                }
            }
        }
         case types.RESET_NEW_WHISTLE_BLOWING_WITHOUT_COMPLAINT_NUMBER: {
            return {
                ...state,
                whistleBlowing: {
                    ...state.whistleBlowing,
                    fullName: null,
                    email: null,
                    mobileNumber: null,
                    comment:null,
                },
                documents : {
                    documentList: [],
                },
            }
        }
        
                case types.TOGGLE_CONFRIM_POPUP:
                    return {
                        ...state,
                        confirmPopup: {
                            ...state.confirmPopup,
                            showConfirmPopup: action.payload.showConfirmPopup,
                            message: action.payload.message,
                            showYes: action.payload.isConfirm,
                            showNo: action.payload.isConfirm,
                            showOk: action.payload.isInfo,
                            isComp: action.payload.isComp,
                            resolve: action.payload.resolve,
                            title: action.payload.title,
        
                        }
        
                    }
                            case types.CONFIRM_YES:
                                if (state.confirmPopup.resolve) {
                                    state.confirmPopup.resolve(true); // Resolving with "true" when confirmed
                                }
                                return {
                                    ...state,
                                    confirmPopup: {
                                        ...state.confirmPopup,
                                        showConfirmPopup: false,
                                        message: null,
                                        resolve: null,
                                        showYes: false,
                                        showNo: false,
                                        showOk: false,
                                    }
                    
                                }
                            case types.CONFIRM_NO:
                                if (state.confirmPopup.resolve) {
                                    state.confirmPopup.resolve(false); // Resolving with "true" when confirmed
                                }  // Resolve the promise with "false"
                                return {
                                    ...state,
                                    confirmPopup: {
                                        ...state.confirmPopup,
                                        showConfirmPopup: false,
                                        message: null,
                                        resolve: null,
                                        showYes: false,
                                        showNo: false,
                                        showOk: false
                                    }
                    
                                }
        default:
            return state;
    }
}
